module.exports = __webpack_public_path__ + "static/sommer-6a07c921a924b59899f75bc544dd1869.jpg";